import { CareTeamMemberRole } from 'fhir/CareTeam/constants'
import { careTeamContactRoles } from '../constants'

export const isCareTeamMemberContact = (role: CareTeamMemberRole): boolean => {
  return careTeamContactRoles.includes(role)
}

export const diagnosisDateRangeValidator = (_, value: any): Promise<void> => {
  if (!value || !value[0]) {
    return Promise.reject(new Error('Start time is required!'))
  }
  return Promise.resolve()
}
